"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _typeahead = require("./typeahead.style");
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const TypeaheadSelect = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      value,
      options,
      icon,
      iconPosition,
      id,
      onChange,
      onSuggestionSelect,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      maxSuggestion = 5,
      select = false,
      enableNormalization = true,
      width
    } = props,
    rest = __rest(props, ["value", "options", "icon", "iconPosition", "id", "onChange", "onSuggestionSelect", "maxSuggestion", "select", "enableNormalization", "width"]);
  const [mouseEnter, setMouseEnter] = (0, _react.useState)(false);
  const [showSuggestion, setShowSuggestion] = (0, _react.useState)(false);
  const [suggestion, setSuggestion] = (0, _react.useState)(options);
  const [selectedSuggestion, setSelectedSuggestion] = (0, _react.useState)(null);
  const [inputText, setInputText] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    const sugg = (options || []).filter(item => item.value === value);
    setInputText(sugg.length ? sugg[0].label : '');
    setSelectedSuggestion(sugg.length ? sugg[0] : null);
  }, [value]);
  (0, _react.useEffect)(() => {
    if ((selectedSuggestion === null || selectedSuggestion === void 0 ? void 0 : selectedSuggestion.label) !== inputText) {
      let sugg = (0, _toConsumableArray2["default"])(options || []);
      sugg = sugg.filter(option => {
        if (enableNormalization) {
          return option.label.toLocaleLowerCase().search(new RegExp(normalizeInput(inputText.toLocaleLowerCase()), 'i')) !== -1;
        } else {
          return option.label.toLocaleLowerCase().includes(inputText.toLocaleLowerCase());
        }
      });
      setSuggestion(sugg);
    } else {
      setSuggestion(options);
    }
  }, [inputText, options, selectedSuggestion]);
  const onInputClick = () => {
    if (suggestion && suggestion.length) {
      setShowSuggestion(true);
    }
  };
  const onInputBlur = () => {
    if (!mouseEnter) {
      setShowSuggestion(false);
    }
  };
  const onInputChange = e => {
    setInputText(e.target.value);
    if (typeof onChange === 'function') {
      onChange(e);
    }
  };
  const onSuggestionClick = item => {
    setInputText(item.label);
    setSelectedSuggestion(item);
    setShowSuggestion(false);
    if (typeof onSuggestionSelect === 'function') {
      onSuggestionSelect(item);
    }
    setMouseEnter(false);
  };
  const onClear = () => {
    if (typeof onSuggestionSelect === 'function') {
      onSuggestionSelect(null);
    }
    setInputText('');
  };
  const normalizeInput = value => {
    return value.replace(',', '').replace(/\s/g, '');
  };
  const onMouseEnter = () => {
    setMouseEnter(true);
  };
  const onMouseLeave = () => {
    setMouseEnter(false);
  };
  const isEllipsActive = id => {
    if (typeof window !== 'undefined') {
      const inputText = document.getElementById(id);
      return inputText ? (inputText === null || inputText === void 0 ? void 0 : inputText.offsetWidth) < (inputText === null || inputText === void 0 ? void 0 : inputText.scrollWidth) : false;
    }
  };
  return (0, _jsxRuntime.jsxs)(_typeahead.Components.Wrapper, {
    children: [isEllipsActive(id) ? (0, _jsxRuntime.jsx)(_Tooltip["default"], (0, _extends2["default"])({
      content: inputText,
      width: 'auto',
      position: "top",
      appearance: "default",
      zIndex: 99999
    }, {
      children: (0, _jsxRuntime.jsx)(_typeahead.Components.InputElement, (0, _extends2["default"])({
        id: id,
        value: inputText,
        onClick: onInputClick,
        onChange: e => onInputChange(e),
        onBlur: onInputBlur,
        clearButton: true,
        onClear: onClear,
        icon: showSuggestion ? 'chevron-up' : 'chevron-down',
        iconPosition: "right",
        ref: ref,
        focus: showSuggestion,
        select: select,
        width: width
      }, rest))
    })) : (0, _jsxRuntime.jsx)(_typeahead.Components.InputElement, (0, _extends2["default"])({
      id: id,
      value: inputText,
      onClick: onInputClick,
      onChange: e => onInputChange(e),
      onBlur: onInputBlur,
      clearButton: true,
      onClear: onClear,
      icon: showSuggestion ? 'chevron-up' : 'chevron-down',
      iconPosition: "right",
      ref: ref,
      focus: showSuggestion,
      select: select,
      width: width
    }, rest)), showSuggestion && (0, _jsxRuntime.jsx)(_typeahead.Components.OptionsContainer, (0, _extends2["default"])({
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, {
      children: (0, _jsxRuntime.jsx)(_typeahead.Components.OptionsList, (0, _extends2["default"])({
        "$type": "select"
      }, {
        children: suggestion && suggestion.length ? suggestion.map(item => (0, _jsxRuntime.jsx)(_typeahead.Components.OptionsListItem, (0, _extends2["default"])({
          onClick: () => onSuggestionClick(item)
        }, {
          children: item.label
        }), item.id)) : (0, _jsxRuntime.jsx)(_typeahead.Components.OptionsListItem, {
          children: "No Options"
        })
      }))
    }))]
  });
});
var _default = exports["default"] = TypeaheadSelect;